import { useDispatch } from "react-redux";
import { useLocation } from "react-router-dom";
import { useEffect } from "react";
import { UpdateApplication } from "../redux/actions/Application";
import { parse } from "date-fns";

export const usePrefillApplication = () => {
  const dispatch = useDispatch();
  const location = useLocation();

  useEffect(() => {
    const parsed = parseQuery(location.search);
    const updateData: { [key: string]: string } = {}
    if (parsed.firstName) {
      updateData.firstName = parsed.firstName;
    }
    if (parsed.lastName) {
      updateData.lastName = parsed.lastName;
    }
    if (parsed.email) {
      updateData.email = parsed.email;
    }
    if (parsed.phoneNumber) {
      updateData.phone = parsed.phoneNumber;
    }
    if (parsed.leaseStart) {
      updateData.coverageStart = parse(parsed.leaseStart, 'MM/dd/yyyy', new Date()).toISOString();
    }
    if (parsed.addressCity) {
      updateData.addressCity = parsed.addressCity;
    }
    if (parsed.addressState) {
      updateData.addressState = parsed.addressState;
    }
    if (parsed.addressZip) {
      updateData.addressZip = parsed.addressZip;
    }
    if (parsed.addressUnit) {
      updateData.addressUnit = parsed.addressUnit;
    }
    if (parsed.addressStreet) {
      updateData.addressStreet = parsed.addressStreet;
    }
    if(parsed.roommateFirstName) {
      updateData.roommateFirstName = parsed.roommateFirstName
    }
    if(parsed.roommateLastName) {
      updateData.roommateLastName = parsed.roommateLastName
    }
    if(parsed.roommateEmai) {
      updateData.roommateEmai = parsed.roommateEmai
    }
    if(Object.keys(updateData).length){
      dispatch(UpdateApplication(updateData));
    }
  }, [dispatch, location.search])
}

function parseQuery(queryString: string) {
  const query: { [ k: string]: string } = {};
  const pairs = (queryString[0] === '?' ? queryString.substr(1) : queryString).split('&');
  for (let i = 0; i < pairs.length; i++) {
    const pair = pairs[i].split('=');
    query[decodeURIComponent(pair[0])] = decodeURIComponent(pair[1] || '');
  }
  return query;
}
